import { Grid, TableCell, TableRow } from "@material-ui/core";
import { ArrowUpward, Menu, Publish } from "@material-ui/icons";
import React from "react";
import { getClickButton } from "../../../../functions/getButtons";
import IAPI from "../../../../models/IAPI";
import { CustomAPIID } from "../../functions/sharedFunctions";
import { IntegrationStatuses } from "../../IntegrationStatuses";
import IIntegration from "../../../../models/IIntegration";
import { useIntegrationContext } from "../../contexts/IntegrationContext";

export interface IIntegrationAPIRowProps {
  api: IAPI;
  showFieldButtons: boolean;
  integration: IIntegration;
}

function IntegrationAPIRow(props: IIntegrationAPIRowProps) {
  const { api, showFieldButtons, integration } = props;
  const { setShowXMLFieldsDialog, setShowCustomAPIFieldsDialog, setShowSubmitForProductionDialog } = useIntegrationContext();

  const getButtons = () => {
    if (api.ID === CustomAPIID && showFieldButtons) {
      return (
        <Grid container spacing={1}>
          <Grid item>{getClickButton("Upload Fields", <ArrowUpward />, () => setShowXMLFieldsDialog(true))}</Grid>
          <Grid item>{getClickButton("View Fields", <Menu />, () => setShowCustomAPIFieldsDialog(true))}</Grid>
          {integration.Status.ID === IntegrationStatuses.AvailableForCustomers && (
            <Grid item>{getClickButton("Request Field Review", <Publish />, () => setShowSubmitForProductionDialog(true))}</Grid>
          )}
        </Grid>
      );
    }
  };

  return (
    <TableRow>
      <TableCell>{api.Name}</TableCell>
      <TableCell>{api.Method.Name}</TableCell>
      <TableCell>{api.Description}</TableCell>
      <TableCell>{getButtons()}</TableCell>
    </TableRow>
  );
}

export default IntegrationAPIRow;
